module.exports = __webpack_public_path__ + "static/media/weather2.fcc1f30a.png";